/*@flow*/
import store from 'store';
import getIn from 'lib/getIn';

export default function state(path: any, notSetValue?: any, options?: Object): any {
  let reduxStore = store;
  if (options && options.store) {
    reduxStore = options.store;
    delete options.store;
  }
  const get = getIn(reduxStore.getState);
  return get(path, notSetValue);
}
